// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { loadLazyWithTimeoutRetry } from '@backoffice-frontend/lazy-loading'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { AppAccessControlAreaId } from './AppAccessControlAreaId'
import { AppAccessControlAreaNavigation } from './AppAccessControlAreaNavigation'
import { AppAccessControlAreaRoutes } from './AppAccessControlAreaRoutes'

const LazyAppAccessControlComponent = lazy(() =>
  loadLazyWithTimeoutRetry(() => import('./AppAccessControlArea')),
)

const AppAccessControlComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyAppAccessControlComponent />
  </SuspenseLoadingWrapper>
)

export const AppAccessControlArea = {
  id: AppAccessControlAreaId,
  requiredRight: BoumRight.AREA_SIGNUP_ALLOWLIST,
  NavigationComponent: AppAccessControlAreaNavigation,
  route: {
    path: AppAccessControlAreaRoutes.route,
    component: AppAccessControlComponent,
  },
}
